namespace TabAurous.ProductDevelopment {
    export interface StagesRow {
        StageId?: number;
        StageName?: string;
        Narration?: string;
        AllowPrivateComment?: boolean;
        AllowPublicComment?: boolean;
        SendEmail?: boolean;
        Members?: StageMembersRow[];
    }

    export namespace StagesRow {
        export const idProperty = 'StageId';
        export const nameProperty = 'StageName';
        export const localTextPrefix = 'ProductDevelopment.Stages';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            StageId = "StageId",
            StageName = "StageName",
            Narration = "Narration",
            AllowPrivateComment = "AllowPrivateComment",
            AllowPublicComment = "AllowPublicComment",
            SendEmail = "SendEmail",
            Members = "Members"
        }
    }
}
